import { render, staticRenderFns } from "./custom_news.vue?vue&type=template&id=1435e775&scoped=true&"
import script from "./custom_news.vue?vue&type=script&lang=js&"
export * from "./custom_news.vue?vue&type=script&lang=js&"
import style0 from "./custom_news.vue?vue&type=style&index=0&id=1435e775&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435e775",
  null
  
)

export default component.exports